import React from 'react'
import { View } from 'react-native'

import { ViewPropTypes } from 'deprecated-react-native-prop-types'
import PropTypes from 'prop-types'

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { loadingConfig, shimmerPlaceholderConfig } from './AppointmentCardLoading.Config'
import styles from './AppointmentCardLoading.Styles'

const AppointmentCardLoading = ({ containerStyle }) => {
  const theme = useTheme()
  return (
    <View style={[styles.cardContainer(theme), containerStyle]}>
      <Shimmer
        config={loadingConfig(theme)}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    </View>
  )
}

AppointmentCardLoading.propTypes = {
  containerStyle: ViewPropTypes.style,
}

export default AppointmentCardLoading
